import { DateRangeCustomFilterEnum as e, DateRangeFilterEnum as t } from "../../types/date-range-filter-enum.js";
import { setDateWithTimezone as n } from "@systemeio/util";
//#region src/date-picker/date-range-picker/utils/set-active-filter-value.ts
var r = (t) => Object.values(e).includes(t), i = ({ activeFilter: e, customFilters: i, setDateRange: a, timezone: o }) => {
	if (r(e)) {
		let t = i.find((t) => t.slug === e)?.handler;
		t && a(t());
		return;
	}
	switch (e) {
		case t.Last30Days: {
			let e = n("", o);
			e.setHours(23, 59, 59, 999);
			let t = new Date(e);
			t.setDate(t.getDate() - 30), t.setHours(0, 0, 0, 0), a([t, e]);
			break;
		}
		case t.ThisMonth: {
			let e = n("", o), t = e.getFullYear(), r = e.getMonth();
			a([new Date(t, r, 1), new Date(t, r + 1, 0)]);
			break;
		}
		case t.LastMonth: {
			let e = n("", o), t = e.getFullYear(), r = e.getMonth();
			a([new Date(t, r - 1, 1), new Date(t, r, 0)]);
			break;
		}
	}
};
//#endregion
export { i as setActiveFilterValue };
